import { menuData } from "../data/menu";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import MenuHero from "../components/menu/MenuHero";
import MenuNav from "../components/menu/MenuNav";
import MenuSection from "../components/menu/MenuSection";
import { motion } from "framer-motion";

export default function MenuPage() {
  return (
    <div className="min-h-screen bg-sand text-[var(--color-text-base)]">
      <Header />

      <main>
        <MenuHero />

        <MenuNav categories={menuData} />

        {/* Intro text */}
        <motion.div
          className="max-w-3xl mx-auto px-4 sm:px-6 pt-14 pb-4 text-center"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          viewport={{ once: true, margin: "-100px" }}
        >
          <p className="text-[var(--color-text-muted)] text-base sm:text-lg leading-relaxed">
            Nuestra carta trae lo mejor de la costa ecuatoriana a tu mesa.
            Ingredientes frescos del día, recetas de tradición y el sazón que
            solo El Verde puede darte.
          </p>
        </motion.div>

        {/* Menu content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-24">
          {menuData.map((category) => (
            <MenuSection key={category.id} category={category} />
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}
